import { writable, get } from 'svelte/store';
export const createProjectConfigStore = () => {
    const projectsStore = writable([]);
    const setProjects = (projects) => projectsStore.set(projects);
    const getProjects = () => get(projectsStore);
    return {
        subscribe: projectsStore.subscribe,
        setProjects,
        getProjects,
    };
};
